export const SOFTLINE_PERMISSION_ESL_STORAGE = 'SOFTAPPS.ESL_LINK_STORAGE';
